import { CommonModule, DatePipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UtilDateFormats } from 'src/app/5.transversal/5.2.utils/util.constants';
import { MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ViewMain } from '../../2.view/view.main/view.main';

//-- Modules
import { AppModuleRouting } from './app.module.routing';
import { AppModuleProvider } from './app.module.provider'
import { AppModuleMaterial } from './app.module.material'

//-- Views
import { ViewUserData } from '../../2.view/view.user.data/view.user.data';

//-- Dialogs
import { ComponentDialogAlert } from '../../2.view/view.components/component.dialog.alert/component.dialog.alert';
import { ComponentDialogTerms } from '../../2.view/view.components/component.dialog.terms/component.dialog.terms';
import { ComponentDialogSchedule } from '../../2.view/view.components/component.dialog.schedule/component.dialog.schedule';

//-- Directives
import { DirectiveTenDigit } from '../../5.transversal/5.3.directives/directive.ten.digits';

@NgModule({
    declarations: [
        ViewMain,
        ViewUserData,
        ComponentDialogAlert,
        ComponentDialogTerms,
        ComponentDialogSchedule,
        DirectiveTenDigit
    ],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        AppModuleRouting,
        AppModuleProvider,
        AppModuleMaterial,
        NgxSpinnerModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports:[
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    entryComponents: [
        ComponentDialogAlert,
        ComponentDialogTerms,
        ComponentDialogSchedule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        DatePipe,
        { 
            provide: MAT_DATE_LOCALE, 
            useValue: "es" 
        },{ 
            provide: MAT_DATE_FORMATS, 
            useValue: UtilDateFormats 
        }
    ],
    bootstrap: [ViewMain]
})
export class AppModule { }